function AppearOnScroll() {
	this.scenes = [];
	this.build();
	barbaCallbacks.push(this);
	resizeCallbacks.push(this);
}

AppearOnScroll.prototype.build = function () {

	let that = this;

	$('.appear-on-scroll').each(function (index, elem) {
		let offset = -window.innerHeight / 2.5;
		let delay = 0;

		if ($(elem).data('appear-on-scroll-offset')) {
			offset = offset + $(elem).data('offset');
		}

		if ($(elem).data('appear-on-scroll-delay')) {
			delay = $(elem).data('appear-on-scroll-delay');
		}

		that.scenes.push(scrollAnim(elem, elem, 1, offset, {
			delay: delay
		}).on('start', function () {
			setTimeout(function () {
				$(elem).addClass('appear');
			}, delay);
		}));
	});

};

AppearOnScroll.prototype.resize = function () {
	if (this.scenes && this.scenes.length) {
		this.scenes.forEach(function (scene) {
			scene.destroy(true);
		});
		this.scenes = [];
		this.build();
	}
};
